import React from 'react';
import { useHistory } from 'react-router-dom';
import { postRecordatorio } from '../../routing/routes';
import LoadingGIF from '../assets/loading.gif';
import Reminders from './RemindersComponent';

const CreateReminders = ({ archivos, functionesChatbot, refreshData, setNotification, nodos }) => {
	const history = useHistory();

	function createRecordatorio(nuevoRecordatorio) {
		const tmp = { ...nuevoRecordatorio };
		postRecordatorio(tmp)
			.then(() => {
				setNotification('mrecordatorio creado correctamente!');
				refreshData();
				history.push('/recordatorios');
			})
			.catch(() => {
				setNotification('eNo ha sido posible crear el recordatorio!');
				refreshData();
				history.push('/recordatorios');
			});
	}

	const recordatorio = {
		habilitado: false,
		global: false,
		nodos: [],
		numeroRecordatorios: 1,
		tiempoEspera: 1,
		scripts: [],
		nombre: '',
		botones: [],
	};

	if (recordatorio) {
		return (
			<Reminders
				recordatorio={recordatorio}
				archivos={archivos}
				refreshData={refreshData}
				setNotification={setNotification}
				functionesChatbot={functionesChatbot}
				nodos={nodos}
				operacion={createRecordatorio}
			/>
		);
	} else {
		return (
			<div style={{ margin: '100px 0px' }}>
				<h3 style={{ textAlign: 'center' }}>CARGANDO...</h3>
				<div style={{ textAlign: 'center' }}>
					<span>
						<img style={{ height: '200px', width: '200px' }} src={LoadingGIF} alt={'Cargando'} />
					</span>
				</div>
			</div>
		);
	}
};

export default CreateReminders;
